const authInitialReducerState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  rememberMe: false,
  status: "",
  error: null,
};

export { authInitialReducerState };
